import { CompanionDesignRoute } from '@/features/companion/CompanionDesign';
import { CompanionPreview } from '@/features/companion/companionPreview';
import { CompanionRoute, CompanionParentRoute } from '@/features/companion/CompanionRoutes';
import { MembershipPage, MembershipPublicPage } from '@/features/membership/MembershipPage';
import { MembershipDemoPage } from '@/features/membership/MembershipDemoPage';
import { ChemistryLabStudyEntry } from '@/pages/labs/chemistry/ChemistryLabStudyEntry';
import { ChemistryLabPage } from '@/pages/labs/chemistry/ChemistryLabPage';
import { PhysicsLabStudyEntry } from '@/pages/labs/physics/PhysicsLabStudyEntry';
import { PhysicsLabPage } from '@/pages/labs/physics/PhysicsLabPage';
import { StudySelfAssessmentPage } from '@/pages/learn/study/StudySelfAssessmentPage';
import { LmsDemoPage } from '@/pages/lms-demo/LmsDemoPage';
import { SchoolLearningPage } from '@/pages/portal/SchoolLearningPage';
import { createStudyAwareRouter } from '@/pages/try/studyExperience/router';
import { ParentCoursesPage } from '@/pages/portal/ParentCoursesPage';
import { StudyParentPage } from '@/pages/portal/StudyParentPage';
import { StudyTutorGuidePage } from '@/pages/StudyTutorGuidePage';
import { StudyNotesPage } from '@/pages/learn/study/StudyNotesPage';
import { StudyCheatsheetsPage } from '@/pages/learn/study/cheatsheets/StudyCheatsheetsPage';
import { StudyPlanRedirect, StudyYearRedirect } from '@/pages/learn/study/StudyRetiredRedirects';
import { StudyJourneyPage } from '@/pages/learn/study/StudyJourneyPage';
import { StudySettingsPage } from '@/pages/learn/study/StudySettingsPage';
import { StudyWrapUpPage } from '@/pages/learn/study/StudyWrapUpPage';
import { StudyNewWorkingPage } from '@/pages/learn/study/StudyNewWorkingPage';
import { DesktopMemoryPage } from '@/pages/portal/desktop/DesktopMemoryPage';
import { MemoryPanel } from '@/pages/portal/desktop/MemoryPanel';
import {
  LearnPlaygroundPage,
  EngineSandboxDevPage,
  NotificationCenterPage,
  AuditProjectPage,
  BillingPage,
  ChallengeHubRoute,
  ChallengeRegisterPage,
  ChallengeReportPage,
  ClassCheckoutPage,
  AcademyCheckoutPage,
  SelfPacedCoursePage,
  SelfPacedCoursesPage,
  AcademyOrderPage,
  AcademyPage,
  AcademyProductDetailPage,
  AcademySessionReportPage,
  ClassesAndCoursesPage,
  CourseDetailPage,
  DashboardPage,
  ExplorePage,
  SchoolResearchPage,
  PathwayNavigatorPage,
  LegacyClassesRedirect,
  GuidesPage,
  FamilyDetailPage,
  KidGrowthPage,
  StudySupportReportPage,
  KidProjectsPage,
  MyProjectsPage,
  MorePage,
  PluginHostPage,
  KidCreatorPassportPage,
  KidImagesPage,
  FamilyNewPage,
  PortalLoginPage,
  RegisterPage,
  SettingsPage,
  TeacherDetailPage,
  TutoringHubPage,
  WalletPage,
  WalletTopupPage,
  StarsGuidePage,
  WalletAutoTopupPage,
  UsagePage,
  DesktopDevicesPage,
  DesktopPairPage,
  KidUsagePage,
  HscPlannerPage,
  SeniorPathwayPage,
  PromotionRewardsPage,
  ClassCodePage,
  TemporaryClassLoginPage,
  LearnHomePage,
  LearnLoginPage,
  StudentSignupPage,
  StudentStarsTopupPage,
  StudentAccountLayout,
  StudentAccountHomePage,
  StudentAccountSettingsPage,
  StudyPurchasePage,
  FamilyLinkAcceptPage,
  KidHandoffPage,
  LessonsCatalogPage,
  PackLessonsPage,
  LearnProfilePage,
  ProjectDetailPage,
  ProjectNewPage,
  ProjectsListPage,
  CreateHubPage,
  LearnGalleryPage,
  PortalGalleryPage,
  CodeHubPage,
  BlocksHubPage,
  BlocksStudioRoutePage,
  JourneyWestMapPage,
  JourneyWestPartRoute,
  CodeStudioPage,
  CodeRunPage,
  ClassroomListPage,
  ClassHubPage,
  ClassGamesWallPage,
  ClassPostPage,
  WorkspacePage,
  MusicStudioPage,
  AcademyPracticePage,
  AcademyPreviewPage,
  AcademyProductPage,
  AcademyMockExamPage,
  MyExamPrepPage,
  CoursesPage,
  CoursePage,
  HscPlanPage,
  ChemicalEquationLabPage,
  AlgebraMachinePage,
  AnglesTrigonometryPage,
  CoordinateDistancePage,
  CoordinateTransformationsPage,
  DataProbabilityPage,
  FormulaLibraryPage,
  FractionRatioLabPage,
  FunctionsGraphsPage,
  GeometryMeasurementPage,
  IndicesPowersPage,
  LogarithmExplorerPage,
  MoneyModelsPage,
  QuadraticSolverPage,
  RatesCalculusPage,
  SequencesGrowthPage,
  SimultaneousEquationsPage,
  MoleculeLabPage,
  ChromatographyLabPage,
  EquilibriumLabPage,
  OrganicChemistryBuilderPage,
  SpectroscopyDetectivePage,
  PHTitrationLabPage,
  IonicEquationLabPage,
  MatterChangeLabPage,
  ReactionPredictorPage,
  ReactionRateLabPage,
  RedoxLabPage,
  StoichiometryLabPage,
  StudyHomePage,
  PeriodicTablePage,
  CircuitsPage,
  BiologyToolPage,
  EarthScienceToolPage,
  EnergyTransferPage,
  ProjectileMotionPage,
  LightRefractionPage,
  PhysicsDomainPage,
  HalfLifePage,
  MotionGraphLabPage,
  PhysicsFormulasPage,
  VectorsForcesPage,
  WavesLabPage,
  StudyReviewPage,
  StudyMaterialsLibraryPage,
  StudyMaterialAnalysisPage,
  StudySessionPage,
  StudySubjectPage,
  StudyMindMapEditorPage,
  StudyToolsHubPage,
  StudySubjectsPage,
  ChallengeSubmitPage,
  CreatorPassportPage,
  ClassDashboardPage,
  LiveViewPage,
  TeacherProjectLivePage,
  TeacherSurfaceHandoffPage,
  TeacherPrepStudioPage,
  AssessmentPage,
  ArtStudioPage,
  ArtHubPage,
  VoiceBoothPage,
  VideoStudioPage,
  VideoStudioWorkspacePage,
  PublicPlayPage,
  SubmissionPlayPage,
  TryBlocksPage,
  TryPlaygroundPage,
  TryArtPage,
  TryMusicPage,
  TryVideoPage,
  SiblingDiscountDemoPage,
  MathToolDemoPage,
  PublicVotePage,
  JourneyToWestC1PreviewPage,
  CampaignExperiencePage,
} from './routePages';
import { Navigate } from 'react-router-dom';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { SHOW_LESSONS_CATALOG } from '@/lib/features';
import { LearnLayout } from './LearnLayout';
import { PortalLayout } from './PortalLayout';
import { TeacherLayout } from './TeacherLayout';

import { NotFoundPage } from '@/pages/NotFoundPage';
import { RootPage } from '@/pages/RootPage';

// The Phaser game studio. `/learn/playground/:projectId` (LearnPlaygroundPage)
// is the authed kid entry the Creative Code Studio card opens; `/learn/playground/new`
// drives the create/landing flow. Phase 1 runs on the local scaffold (no backend
// `game` kind yet — see LearnPlaygroundPage).
// DEV-only engine sandbox (2D Phaser / 3D three.js) — verification harness, gated below.

// Portal pages (parent surface — parent-portal-prd.md §2)

import { SharedStudyReportPage } from '@/pages/portal/SharedStudyReportPage';

import {
  LegacyTeacherProfileRedirect,
  LegacyTeachersRedirect,
} from '@/pages/portal/teachers/LegacyTeachersRedirect';

// Learn pages (kid surface — airbotix-app-learn-prd.md)

import { MyPage } from '@/pages/learn/MyPage';

import { SolutionsLabPage } from '@/pages/learn/study/SolutionsLabPage';
import { ParticleModelLabPage } from '@/pages/learn/study/ParticleModelLabPage';
import { MatterClassifierPage } from '@/pages/learn/study/MatterClassifierPage';
import { EnergyCalorimetryLabPage } from '@/pages/learn/study/EnergyCalorimetryLabPage';
import { AtomicModelsLabPage } from '@/pages/learn/study/AtomicModelsLabPage';
import { ElectrochemicalCellsLabPage } from '@/pages/learn/study/ElectrochemicalCellsLabPage';
import { GasLawsLabPage } from '@/pages/learn/study/GasLawsLabPage';
import { IntermolecularForcesLabPage } from '@/pages/learn/study/IntermolecularForcesLabPage';
import { InstrumentalAnalysisLabPage } from '@/pages/learn/study/InstrumentalAnalysisLabPage';
import { PolymersBiomoleculesLabPage } from '@/pages/learn/study/PolymersBiomoleculesLabPage';
import { CombustionCorrosionLabPage } from '@/pages/learn/study/CombustionCorrosionLabPage';
import { SeparationPlannerLabPage } from '@/pages/learn/study/SeparationPlannerLabPage';
import { MetalsNonmetalsLabPage } from '@/pages/learn/study/MetalsNonmetalsLabPage';
import { ConservationOfMassLabPage } from '@/pages/learn/study/ConservationOfMassLabPage';
import { AcidReactionsLabPage } from '@/pages/learn/study/AcidReactionsLabPage';
import { GroupReactivityLabPage } from '@/pages/learn/study/GroupReactivityLabPage';
import { IonsBondingLabPage } from '@/pages/learn/study/IonsBondingLabPage';
import { AcidBaseCalculationsLabPage } from '@/pages/learn/study/AcidBaseCalculationsLabPage';
import { VolumetricAnalysisLabPage } from '@/pages/learn/study/VolumetricAnalysisLabPage';
import { WaterChemistryLabPage } from '@/pages/learn/study/WaterChemistryLabPage';
import { MaterialsChemistryLabPage } from '@/pages/learn/study/MaterialsChemistryLabPage';
import { FuelsSustainabilityLabPage } from '@/pages/learn/study/FuelsSustainabilityLabPage';
import { SynthesisDesignLabPage } from '@/pages/learn/study/SynthesisDesignLabPage';

import {
  StudyWorkingLibraryPage,
  StudySavedWorkingPage,
} from '@/pages/learn/study/StudyWorkingLibraryPage';

import { StudyAssignmentPage } from '@/pages/learn/study/StudyAssignmentPage';
import { IndividualLearningPlanTaskPage } from '@/pages/learn/study/IndividualLearningPlanTaskPage';
import { StudyMaterialPage } from '@/pages/learn/study/StudyMaterialPage';
// Teacher class-session surface (learn-game-studio-prd §17.12 J12). Teacher is a
// `user` principal (role=teacher); the full console lives in a sibling repo —
// this is the in-app class dashboard + live view + assessment FE.

// PUBLIC, no-auth play host for an external share-link (learn-game-studio-prd
// §17.8 J8 / D-GAME10). Renders ONLY the bare game canvas (no editor/chat/console/
// Game-Runner chrome), no auth token, no LLM — the opaque-origin sandbox only.

// PUBLIC, no-auth "Try it" demos (try-demo-mode-prd.md §2 D-DEMO-01). They render
// the REAL studios wrapped in the demo provider (in-memory state, scripted AI,
// tour overlay) — like /play/:shareId, deliberately NOT under <ProtectedRoute>.

// PUBLIC, no-auth Creative Code Challenge voting + Creator Showcase
// (creative-code-challenge-prd.md §5 flow 7/9, D-CCC-4). Same shape as
// /play/:shareId: top-level, outside every <ProtectedRoute> and both layouts,
// because a voter has no account and D-CCC-4 removed the verification step.

export const router = createStudyAwareRouter(
  [
    { path: '/membership', element: <MembershipPublicPage /> },
    { path: '/demo/membership', element: <MembershipDemoPage /> },
    {
      path: '/preview/academy/:productSlug/:previewProductId',
      element: <AcademyPreviewPage />,
    },
    // Root redirect based on principal kind
    { path: '/', element: <RootPage /> },
    { path: '/study/tutor', element: <StudyTutorGuidePage /> },
    { path: '/labs/physics', element: <PhysicsLabPage /> },
    { path: '/labs/chemistry', element: <ChemistryLabPage /> },

    // PUBLIC external share-link play route — NO auth, NO layout, NO studio chrome.
    // A logged-out visitor (e.g. grandma) opens /play/:shareId and plays the kid's
    // frozen, read-only game snapshot. Deliberately NOT under any <ProtectedRoute>.
    { path: '/play/:shareId', element: <PublicPlayPage /> },

    // PUBLIC no-signup demo experiences (try-demo-mode-prd.md §1 T1/T2) — the
    // marketing site's "Try it free" entry points. No token, no redirect.
    { path: '/try/playground', element: <TryPlaygroundPage /> },
    { path: '/try/blocks', element: <TryBlocksPage /> },
    { path: '/try/art', element: <TryArtPage /> },
    { path: '/try/music', element: <TryMusicPage /> },
    { path: '/try/video', element: <TryVideoPage /> },
    { path: '/try/companion', element: <CompanionPreview /> },
    { path: '/try/study', element: <Navigate to="/learn/study" replace /> },
    { path: '/try/sibling-discount', element: <SiblingDiscountDemoPage /> },
    { path: '/try/lms/:kind/:perspective', element: <LmsDemoPage /> },
    { path: '/try/study/mathematics/:toolId', element: <MathToolDemoPage /> },

    // PUBLIC Creative Code Challenge (PRD §6 "airbotix-app — Public" row). No
    // token, no ProtectedRoute, no analytics: `/vote/:slug` is the voting surface
    // and `/challenge/:slug/showcase` is the Creator Showcase, which outlives the
    // voting window and carries no voting controls.
    { path: '/vote/:slug', element: <PublicVotePage /> },
    { path: '/challenge/:slug/showcase', element: <PublicVotePage mode="showcase" /> },
    // Read-only challenge submission player (D-CCC-11). Opened from super-admin
    // and teacher-console with a short-lived play ticket in the fragment; the
    // ticket is the credential, so this is deliberately NOT under <ProtectedRoute>.
    { path: '/challenge/review/play', element: <SubmissionPlayPage /> },
    // Guest-first campaign claim surface: the prize is revealed before OTP and
    // the OTP flow completes in place instead of redirecting to registration.
    { path: '/portal/campaigns/:slug', element: <CampaignExperiencePage /> },

    // DEV-only engine sandbox — verify the real 2D/3D runtime in a browser. Excluded
    // from the route table in production builds (learn-game-studio-3d-prd.md M3D-2).
    ...(import.meta.env.DEV
      ? [
          { path: '/playground-sandbox', element: <EngineSandboxDevPage /> },
          {
            path: '/experiments/story-blocks/journey-to-the-west/c1',
            element: <JourneyToWestC1PreviewPage />,
          },
        ]
      : []),

    // Portal — parent surface
    // PUBLIC parent view of an Institution weekly Study report (SIR-VIS-05). No sign-in; the
    // token is the only key and the server answers 410 once the school revokes it.
    { path: '/portal/study/shared/:token', element: <SharedStudyReportPage /> },
    // Parent accepts a student's family-link invite from the email
    // (student-self-signup-prd.md §2.3). Public: the page itself sends a
    // signed-out parent through the normal sign-in, then back here.
    { path: '/portal/family-link/:token', element: <FamilyLinkAcceptPage /> },
    { path: '/portal/login', element: <PortalLoginPage /> },
    { path: '/portal/register', element: <RegisterPage /> },
    {
      path: '/portal',
      element: (
        <ProtectedRoute kind="user">
          <PortalLayout />
        </ProtectedRoute>
      ),
      children: [
        // Dashboard is the default landing after login (QPCD-1 reversed 2026-07-20);
        // Courses lives at /portal/courses. /portal/classes remains a compatibility redirect.
        { index: true, element: <DashboardPage /> },
        { path: 'dashboard', element: <Navigate to="/portal" replace /> },
        { path: 'explore', element: <ExplorePage /> },
        { path: 'school-research', element: <SchoolResearchPage /> },
        { path: 'school-learning', element: <SchoolLearningPage /> },
        // Student Work Gallery (student-work-gallery-prd.md §5, J2).
        { path: 'gallery', element: <PortalGalleryPage /> },
        { path: 'pathway', element: <PathwayNavigatorPage /> },
        { path: 'pathways', element: <SeniorPathwayPage /> },
        { path: 'more', element: <MorePage /> },
        { path: 'classes', element: <LegacyClassesRedirect /> },
        { path: 'courses', element: <ClassesAndCoursesPage /> },
        { path: 'courses/:courseSlug', element: <CourseDetailPage /> },
        { path: 'tutoring', element: <TutoringHubPage /> },
        { path: 'tutoring/:slug', element: <TeacherDetailPage /> },
        { path: 'teachers', element: <LegacyTeachersRedirect /> },
        { path: 'teachers/:slug', element: <LegacyTeacherProfileRedirect /> },
        { path: 'self-paced', element: <SelfPacedCoursesPage /> },
        { path: 'self-paced/:slug', element: <SelfPacedCoursePage /> },
        { path: 'academy', element: <AcademyPage /> },
        { path: 'academy/hsc-planner', element: <HscPlannerPage /> },
        { path: 'academy/products/:slug', element: <AcademyProductDetailPage /> },
        { path: 'academy/checkout/:sku', element: <AcademyCheckoutPage /> },
        { path: 'academy/orders/:intentId', element: <AcademyOrderPage /> },
        { path: 'academy/reports/:sessionId', element: <AcademySessionReportPage /> },
        // Pay-now seat checkout — deep-link target for marketing + Portal Courses
        // (class-seat-checkout-prd.md D-CSC-8).
        { path: 'checkout/class/:classId', element: <ClassCheckoutPage /> },
        // The family's view of one challenge: who is entered, who is not, and
        // what the whole thing involves. The Portal nav points HERE, not at the
        // single-child register form — a parent with three children could
        // otherwise only discover their standing by selecting each child in turn.
        { path: 'challenge/:slug', element: <ChallengeHubRoute /> },
        // Creative Code Challenge registration — the marketing CTA's deep-link
        // target (creative-code-challenge-prd.md §5 flow 1, §6 Portal row).
        { path: 'challenge/:slug/register', element: <ChallengeRegisterPage /> },
        // The parent's PRIVATE report (creative-code-challenge-prd.md §5 flow 10).
        // Parent-only like the registration route above — the kid surface has no
        // report route: the backend gates it `@Roles('parent')`, and §9's "may a
        // KID read their own report?" is an OPEN question nobody has answered.
        { path: 'challenge/:slug/report', element: <ChallengeReportPage /> },
        // The parent's OWN projects (parent-owned, private to the owner) — opens
        // the same studios read-write; kids never see these rows.
        { path: 'projects', element: <MyProjectsPage /> },
        { path: 'learning', element: <ParentCoursesPage /> },
        { path: 'learning/classes/:id', element: <ParentCoursesPage kind="class" /> },
        { path: 'learning/self-paced/:id', element: <ParentCoursesPage kind="self-paced" /> },
        // Family lives on Home. Preserve old bookmarks without maintaining a
        // second family destination or duplicate navigation state.
        { path: 'family', element: <Navigate to="/portal" replace /> },
        { path: 'family/new', element: <FamilyNewPage /> },
        { path: 'family/:kidId', element: <KidGrowthPage /> },
        { path: 'family/:kidId/study', element: <StudySupportReportPage /> },
        { path: 'study', element: <StudyParentPage /> },
        // Per-kid Projects surface (parent studio parity): the parent opens any of
        // their kid's projects in the REAL studio routes, read-write.
        { path: 'family/:kidId/projects', element: <KidProjectsPage /> },
        { path: 'family/:kidId/passport', element: <KidCreatorPassportPage /> },
        // Art Studio picture gallery — parent oversight (image-studio-prd.md D-IS-5).
        { path: 'family/:kidId/images', element: <KidImagesPage /> },
        { path: 'family/:kidId/settings', element: <FamilyDetailPage /> },
        { path: 'family/:kidId/companion', element: <CompanionParentRoute /> },
        { path: 'reports', element: <Navigate to="/portal" replace /> },
        { path: 'reports/:kidId/:reportId', element: <Navigate to="/portal" replace /> },
        { path: 'membership', element: <MembershipPage /> },
        { path: 'wallet', element: <WalletPage /> },
        { path: 'rewards', element: <PromotionRewardsPage /> },
        { path: 'wallet/topup', element: <WalletTopupPage /> },
        { path: 'wallet/stars-guide', element: <StarsGuidePage /> },
        { path: 'wallet/auto-topup', element: <WalletAutoTopupPage /> },
        // Family Guides catalogue (parent-portal-family-guides-prd.md §5.1)
        { path: 'guides', element: <GuidesPage /> },
        { path: 'usage', element: <UsagePage /> },
        // Airbotix Hangar desktop (hangar-prd.md §6.1, §8): pairing deep link + computers and rules.
        { path: 'desktop', element: <DesktopDevicesPage /> },
        { path: 'desktop/memory', element: <DesktopMemoryPage /> },
        { path: 'desktop/pair', element: <DesktopPairPage /> },
        { path: 'usage/:kidId', element: <KidUsagePage /> },
        { path: 'approvals', element: <NotificationCenterPage /> },
        { path: 'audit', element: <Navigate to="/portal/more" replace /> },
        { path: 'audit/project/:id', element: <AuditProjectPage /> },
        { path: 'settings', element: <SettingsPage /> },
        { path: 'billing', element: <BillingPage /> },
        // Family Apps host — full screen in PortalLayout (photo-nutrition-p1-integration-prd.md §3.2).
        { path: 'apps/:pluginId', element: <PluginHostPage /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },

    // Public one-use exchange from the Teacher Console client into an app-bound
    // teacher session. The opaque token stays in the URL fragment.
    { path: '/teacher/handoff', element: <TeacherSurfaceHandoffPage /> },

    // Teacher — class-session surface (kind="user", role=teacher). Class dashboard
    // + per-kid live read-only view + assessment (learn-game-studio-prd §17.12 J12).
    {
      path: '/teacher',
      element: (
        <ProtectedRoute kind="user">
          <TeacherLayout />
        </ProtectedRoute>
      ),
      children: [
        { path: 'classes/:classId', element: <ClassDashboardPage /> },
        { path: 'classes/:classId/kids/:kidId', element: <LiveViewPage /> },
        { path: 'classes/:classId/kids/:kidId/assessment', element: <AssessmentPage /> },
        // Teacher read-only LIVE project viewer (teacher-live-project-view-prd D-LV-1).
        { path: 'projects/:projectId/live', element: <TeacherProjectLivePage /> },
        // Teacher EDITABLE prep-project studio (teacher-prep-projects Stage 2). Mounts
        // the real studios editable for the OWNING teacher; deep-linked from
        // teacher-console (Stage 3). Backend (Stage 1) authorizes the prep owner.
        { path: 'prep/:projectId', element: <TeacherPrepStudioPage /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },

    // Learn — kid surface
    { path: '/learn/login', element: <LearnLoginPage /> },
    { path: '/learn/login/at-class', element: <LearnLoginPage /> },
    { path: '/learn/class-code', element: <ClassCodePage /> },
    { path: '/learn/temporary', element: <TemporaryClassLoginPage /> },
    // Public student self-signup (student-self-signup-prd.md §2.1). The page
    // reads the signup switch itself and shows a closed state when it is off.
    { path: '/learn/signup', element: <StudentSignupPage /> },
    // Public, token-in-fragment parent-approved entry. It must sit outside the
    // kid ProtectedRoute because the handoff is what creates the kid session.
    { path: '/learn/handoff', element: <KidHandoffPage /> },
    {
      path: '/learn',
      element: (
        <ProtectedRoute kind="kid">
          <LearnLayout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <LearnHomePage /> },
        { path: 'my', element: <MyPage /> },
        { path: 'projects', element: <ProjectsListPage /> },
        { path: 'projects/new', element: <ProjectNewPage /> },
        { path: 'projects/:id', element: <ProjectDetailPage /> },
        { path: 'passport', element: <CreatorPassportPage /> },
        // Internal route id stays `/learn/missions` (D-LP-2); the catalog & detail
        // pages render the pack's Lessons (课节) → each Lesson's Mission tasks.
        // While the catalog is hidden (features.ts SHOW_LESSONS_CATALOG) the
        // generic routes redirect home; old self-paced links retain their introduction.
        ...(SHOW_LESSONS_CATALOG
          ? [
              { path: 'missions', element: <LessonsCatalogPage /> },
              { path: 'missions/:id', element: <PackLessonsPage /> },
            ]
          : [
              { path: 'missions', element: <Navigate to="/learn" replace /> },
              { path: 'missions/:id', element: <PackLessonsPage selfPacedOnly /> },
            ]),
        // Legacy alias: the class wall is `/learn/classroom` (ClassroomListPage).
        // The old `/learn/wall` was a "Coming soon" placeholder — redirect it.
        { path: 'wall', element: <Navigate to="/learn/classroom" replace /> },
        { path: 'classroom', element: <ClassroomListPage /> },
        { path: 'classroom/:classId', element: <ClassHubPage /> },
        { path: 'classroom/:classId/games', element: <ClassGamesWallPage /> },
        { path: 'classroom/:classId/post/:projectId', element: <ClassPostPage /> },
        { path: 'profile', element: <LearnProfilePage /> },
        // Independent student tops up their own Stars (D-SSU-12).
        { path: 'profile/stars', element: <StudentStarsTopupPage /> },
        // The independent student's own account (student-self-signup-prd.md §17,
        // D-SSU-23): the Parent Portal pages a parent uses about a child, remounted
        // for the student about themselves. Paths mirror `/portal/*`
        // (`STUDENT_ACCOUNT_ROUTES` in accountSurface.tsx); the layout refuses every
        // other kid. Parent-only pages (add a child, PINs, approvals, Hangar) have
        // no twin here.
        {
          path: 'account',
          element: <StudentAccountLayout />,
          children: [
            { index: true, element: <StudentAccountHomePage /> },
            { path: 'membership', element: <MembershipPage /> },
            { path: 'wallet', element: <WalletPage /> },
            { path: 'wallet/topup', element: <WalletTopupPage /> },
            { path: 'wallet/auto-topup', element: <WalletAutoTopupPage /> },
            { path: 'wallet/stars-guide', element: <StarsGuidePage /> },
            { path: 'billing', element: <BillingPage /> },
            { path: 'usage', element: <UsagePage /> },
            { path: 'usage/:kidId', element: <KidUsagePage /> },
            { path: 'settings', element: <StudentAccountSettingsPage /> },
            { path: 'courses', element: <ClassesAndCoursesPage /> },
            { path: 'courses/:courseSlug', element: <CourseDetailPage /> },
            { path: 'checkout/class/:classId', element: <ClassCheckoutPage /> },
            { path: 'tutoring', element: <TutoringHubPage /> },
            { path: 'tutoring/:slug', element: <TeacherDetailPage /> },
            { path: 'self-paced', element: <SelfPacedCoursesPage /> },
            { path: 'self-paced/:slug', element: <SelfPacedCoursePage /> },
            { path: 'academy', element: <AcademyPage /> },
            { path: 'academy/hsc-planner', element: <HscPlannerPage /> },
            { path: 'academy/products/:slug', element: <AcademyProductDetailPage /> },
            { path: 'academy/checkout/:sku', element: <AcademyCheckoutPage /> },
            { path: 'academy/orders/:intentId', element: <AcademyOrderPage /> },
            { path: 'academy/reports/:sessionId', element: <AcademySessionReportPage /> },
            { path: 'challenge/:slug', element: <ChallengeHubRoute /> },
            { path: 'challenge/:slug/register', element: <ChallengeRegisterPage /> },
            { path: 'challenge/:slug/report', element: <ChallengeReportPage /> },
            { path: 'study', element: <StudyPurchasePage /> },
            { path: 'family/:kidId/study', element: <StudySupportReportPage /> },
            { path: 'pathway', element: <PathwayNavigatorPage /> },
            { path: 'guides', element: <GuidesPage /> },
            { path: '*', element: <Navigate to="/learn/account" replace /> },
          ],
        },
        { path: 'memory', element: <MemoryPanel /> },
        { path: 'create', element: <CreateHubPage /> },
        // Student Work Gallery (student-work-gallery-prd.md §5, J1); owned by the Create tab.
        { path: 'gallery', element: <LearnGalleryPage /> },
        // Image / Voice / Video are PAUSED (createTools.ts `comingSoon`, learn PRD
        // v0.7): every visible entry (Create hub, class sheet, workspace picker)
        // hides them, but the routes stay registered so deep links and the harness
        // wallet journeys (kid-create-image, wallet-pause) keep working.
        // Art Studio: hub at `create/image` (tasks + how-it-works + my pictures),
        // canvas at `create/image/canvas`. Landing straight on a blank canvas hid
        // every picture the kid had already made.
        { path: 'create/image', element: <ArtHubPage /> },
        { path: 'create/image/canvas', element: <ArtStudioPage /> },
        // Music Maker is RETIRED — the Music Stage (studio=music in the Workspace)
        // is the single music surface (music-stage-prd §2). Kept as a redirect so
        // old links, bookmarks and class "create for class" rows still land somewhere.
        { path: 'create/music', element: <Navigate to="/learn/music" replace /> },
        { path: 'create/voice', element: <VoiceBoothPage /> },
        { path: 'create/video', element: <VideoStudioPage /> },
        { path: 'video/:projectId', element: <VideoStudioWorkspacePage /> },
        { path: 'create/code', element: <CodeHubPage /> },
        // Blocks Studio (junior block coder, learn-blocks-studio-prd.md §2)
        { path: 'create/blocks', element: <BlocksHubPage /> },
        { path: 'blocks/:projectId', element: <BlocksStudioRoutePage /> },
        // Journey to the West story parts (Story Blocks JtW S1, one part per build task)
        { path: 'story/journey-west', element: <JourneyWestMapPage /> },
        { path: 'story/journey-west/:partId', element: <JourneyWestPartRoute /> },
        { path: 'code/:projectId', element: <CodeStudioPage /> },
        { path: 'code/:projectId/run', element: <CodeRunPage /> },
        // Game studio (Phaser). An immersive /learn child with no Learn top nav;
        // its bottom taskbar owns the Home exit. The Creative Code Studio card routes here.
        // Phase 1: local Phaser scaffold (no backend game kind yet). This authed
        // route is the only entry — `/learn/playground/:projectId` opens a game and
        // `/learn/playground/new` drives the create/landing flow. (Dev/e2e testing
        // uses a route-mocked authed harness, not a separate no-auth route.)
        { path: 'playground/:projectId', element: <LearnPlaygroundPage /> },
        // Music Stage: its OWN immersive surface (music-stage-prd D-MS7). Wedged
        // inside the Workspace's chat shell it got a letterboxed strip while a
        // session sidebar and a chat transcript took the screen — wrong shell for a
        // band. `/learn/music` opens (or reuses) the session and redirects to the
        // session URL so a refresh returns to the same song.
        { path: 'music', element: <MusicStudioPage /> },
        { path: 'music/:sessionId', element: <MusicStudioPage /> },
        // Academy products are fixed exam/year/subject scopes. The old route now
        // migrates into the kid's entitlement-only product library.
        { path: 'academy', element: <Navigate to="/learn/exams" replace /> },
        // Self-paced courses (self-paced-courses-prd.md): own them, see the lessons, start one.
        { path: 'courses', element: <CoursesPage /> },
        { path: 'courses/:slug', element: <CoursePage /> },
        { path: 'exams', element: <MyExamPrepPage /> },
        { path: 'hsc', element: <HscPlanPage /> },
        { path: 'study', element: <StudyHomePage /> },
        { path: 'study/assignments/:assignmentId', element: <StudyAssignmentPage /> },
        {
          path: 'study/learning-plans/tasks/:assignmentId',
          element: <IndividualLearningPlanTaskPage />,
        },
        { path: 'study/year', element: <StudyYearRedirect /> },
        { path: 'study/plan', element: <StudyPlanRedirect /> },
        { path: 'study/journey', element: <StudyJourneyPage /> },
        { path: 'study/wrap-up', element: <StudyWrapUpPage /> },
        { path: 'study/settings', element: <StudySettingsPage /> },
        { path: 'study/cheatsheets', element: <StudyCheatsheetsPage /> },
        { path: 'study/working', element: <StudyWorkingLibraryPage /> },
        { path: 'study/working/new', element: <StudyNewWorkingPage /> },
        { path: 'study/working/:id', element: <StudySavedWorkingPage /> },
        { path: 'study/materials', element: <StudyMaterialsLibraryPage /> },
        { path: 'study/materials/:documentId', element: <StudyMaterialPage /> },
        { path: 'study/materials/:documentId/analysis', element: <StudyMaterialAnalysisPage /> },
        { path: 'study/notes', element: <StudyNotesPage /> },
        { path: 'study/subjects', element: <StudySubjectsPage /> },
        {
          path: 'study/subjects/science/tools/earth-energy-budget',
          element: <EarthScienceToolPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/formulas',
          element: <FormulaLibraryPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/fractions-ratios',
          element: <FractionRatioLabPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/algebra-machine',
          element: <AlgebraMachinePage />,
        },
        {
          path: 'study/subjects/mathematics/tools/simultaneous-equations',
          element: <SimultaneousEquationsPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/functions-graphs',
          element: <FunctionsGraphsPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/quadratic-solver',
          element: <QuadraticSolverPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/geometry-measurement',
          element: <GeometryMeasurementPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/coordinate-transformations',
          element: <CoordinateTransformationsPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/coordinate-distance',
          element: <CoordinateDistancePage />,
        },
        {
          path: 'study/subjects/mathematics/tools/angles-trigonometry',
          element: <AnglesTrigonometryPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/sequences-growth',
          element: <SequencesGrowthPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/logarithm-explorer',
          element: <LogarithmExplorerPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/indices-powers',
          element: <IndicesPowersPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/money-models',
          element: <MoneyModelsPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/rates-calculus',
          element: <RatesCalculusPage />,
        },
        {
          path: 'study/subjects/mathematics/tools/data-probability',
          element: <DataProbabilityPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/matter-change',
          element: <MatterChangeLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/periodic-table',
          element: <PeriodicTablePage />,
        },
        {
          path: 'study/subjects/chemistry/tools/chemistry-lab',
          element: <ChemistryLabStudyEntry />,
        },
        {
          path: 'study/subjects/physics/tools/physics-lab',
          element: <PhysicsLabStudyEntry />,
        },
        {
          path: 'study/subjects/physics/tools/electromagnetism',
          element: <PhysicsDomainPage domainId="electromagnetism" />,
        },
        {
          path: 'study/subjects/physics/tools/thermal',
          element: <PhysicsDomainPage domainId="thermal" />,
        },
        {
          path: 'study/subjects/physics/tools/momentum',
          element: <PhysicsDomainPage domainId="momentum" />,
        },
        {
          path: 'study/subjects/physics/tools/circular-gravity',
          element: <PhysicsDomainPage domainId="circular-gravity" />,
        },
        {
          path: 'study/subjects/physics/tools/modern-physics',
          element: <PhysicsDomainPage domainId="modern-physics" />,
        },
        {
          path: 'study/subjects/physics/tools/formulas',
          element: <PhysicsFormulasPage />,
        },
        {
          path: 'study/subjects/physics/tools/motion-graphs',
          element: <MotionGraphLabPage />,
        },
        {
          path: 'study/subjects/physics/tools/vectors-forces',
          element: <VectorsForcesPage />,
        },
        {
          path: 'study/subjects/physics/tools/circuits',
          element: <CircuitsPage />,
        },
        {
          path: 'study/subjects/physics/tools/waves',
          element: <WavesLabPage />,
        },
        {
          path: 'study/subjects/physics/tools/energy',
          element: <EnergyTransferPage />,
        },
        {
          path: 'study/subjects/science/tools/:toolId',
          element: <EarthScienceToolPage />,
        },
        {
          path: 'study/subjects/biology/tools/cell-explorer',
          element: <BiologyToolPage toolId="cell-explorer" />,
        },
        {
          path: 'study/subjects/biology/tools/cell-division',
          element: <BiologyToolPage toolId="cell-division" />,
        },
        {
          path: 'study/subjects/biology/tools/enzyme-lab',
          element: <BiologyToolPage toolId="enzyme-lab" />,
        },
        {
          path: 'study/subjects/biology/tools/immune-defence',
          element: <BiologyToolPage toolId="immune-defence" />,
        },
        {
          path: 'study/subjects/biology/tools/reproduction',
          element: <BiologyToolPage toolId="reproduction" />,
        },
        {
          path: 'study/subjects/biology/tools/virtual-microscope',
          element: <BiologyToolPage toolId="virtual-microscope" />,
        },
        {
          path: 'study/subjects/biology/tools/growth-lab',
          element: <BiologyToolPage toolId="growth-lab" />,
        },
        {
          path: 'study/subjects/biology/tools/ecosystems',
          element: <BiologyToolPage toolId="ecosystems" />,
        },
        {
          path: 'study/subjects/biology/tools/body-systems',
          element: <BiologyToolPage toolId="body-systems" />,
        },
        {
          path: 'study/subjects/biology/tools/classification-keys',
          element: <BiologyToolPage toolId="classification-keys" />,
        },
        {
          path: 'study/subjects/biology/tools/plant-transport-lab',
          element: <BiologyToolPage toolId="plant-transport-lab" />,
        },
        {
          path: 'study/subjects/biology/tools/field-sampling-lab',
          element: <BiologyToolPage toolId="field-sampling-lab" />,
        },
        {
          path: 'study/subjects/biology/tools/biotechnology-lab',
          element: <BiologyToolPage toolId="biotechnology-lab" />,
        },
        {
          path: 'study/subjects/biology/tools/evolution',
          element: <BiologyToolPage toolId="evolution" />,
        },
        {
          path: 'study/subjects/biology/tools/gene-expression',
          element: <BiologyToolPage toolId="gene-expression" />,
        },
        {
          path: 'study/subjects/biology/tools/cell-energy',
          element: <BiologyToolPage toolId="cell-energy" />,
        },
        {
          path: 'study/subjects/biology/tools/membrane-transport',
          element: <BiologyToolPage toolId="membrane-transport" />,
        },
        {
          path: 'study/subjects/biology/tools/genetics',
          element: <BiologyToolPage toolId="genetics" />,
        },
        {
          path: 'study/subjects/biology/tools/protein-factory',
          element: <BiologyToolPage toolId="protein-factory" />,
        },
        {
          path: 'study/subjects/physics/tools/projectile',
          element: <ProjectileMotionPage />,
        },
        {
          path: 'study/subjects/physics/tools/light',
          element: <LightRefractionPage />,
        },
        {
          path: 'study/subjects/physics/tools/half-life',
          element: <HalfLifePage />,
        },
        {
          path: 'study/subjects/chemistry/tools/equation-lab',
          element: <ChemicalEquationLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/molecule-bonding',
          element: <MoleculeLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/stoichiometry-lab',
          element: <StoichiometryLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/ionic-equation-lab',
          element: <IonicEquationLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/redox-lab',
          element: <RedoxLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/reaction-predictor',
          element: <ReactionPredictorPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/reaction-rate',
          element: <ReactionRateLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/equilibrium',
          element: <EquilibriumLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/organic-builder',
          element: <OrganicChemistryBuilderPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/spectroscopy',
          element: <SpectroscopyDetectivePage />,
        },
        {
          path: 'study/subjects/chemistry/tools/chromatography',
          element: <ChromatographyLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/ph-titration',
          element: <PHTitrationLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/solutions',
          element: <SolutionsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/particle-model',
          element: <ParticleModelLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/matter-classifier',
          element: <MatterClassifierPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/energy-calorimetry',
          element: <EnergyCalorimetryLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/atomic-models',
          element: <AtomicModelsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/electrochemical-cells',
          element: <ElectrochemicalCellsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/gas-laws',
          element: <GasLawsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/intermolecular-forces',
          element: <IntermolecularForcesLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/instrumental-analysis',
          element: <InstrumentalAnalysisLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/polymers-biomolecules',
          element: <PolymersBiomoleculesLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/combustion-corrosion',
          element: <CombustionCorrosionLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/separation-planner',
          element: <SeparationPlannerLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/metals-nonmetals',
          element: <MetalsNonmetalsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/conservation-of-mass',
          element: <ConservationOfMassLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/acid-reactions',
          element: <AcidReactionsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/group-reactivity',
          element: <GroupReactivityLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/ions-bonding',
          element: <IonsBondingLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/acid-base-calculations',
          element: <AcidBaseCalculationsLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/volumetric-analysis',
          element: <VolumetricAnalysisLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/water-chemistry',
          element: <WaterChemistryLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/materials-chemistry',
          element: <MaterialsChemistryLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/fuels-sustainability',
          element: <FuelsSustainabilityLabPage />,
        },
        {
          path: 'study/subjects/chemistry/tools/synthesis-design',
          element: <SynthesisDesignLabPage />,
        },
        { path: 'study/subjects/:subjectKey/tools', element: <StudyToolsHubPage /> },
        { path: 'study/subjects/:subjectKey', element: <StudySubjectPage /> },
        // Study Mind map editor, full screen (study-mind-map-prd.md §4).
        {
          path: 'study/subjects/:subjectKey/mind-maps/:mapId',
          element: <StudyMindMapEditorPage />,
        },
        { path: 'study/sessions/:sessionId', element: <StudySessionPage /> },
        { path: 'study/review', element: <StudyReviewPage /> },
        { path: 'study/self-assessments/:analysisId/:setId', element: <StudySelfAssessmentPage /> },
        // Creative Code Challenge — the child's own submission screen
        // (creative-code-challenge-prd.md §5 flow 4, §6 Learn row). Deep-linked by
        // slug, not a top-level nav item, so it stays out of LearnTopBar.
        { path: 'challenge/:slug/submit', element: <ChallengeSubmitPage /> },
        { path: 'exams/:productSlug', element: <AcademyProductPage /> },
        { path: 'exams/:productSlug/practice', element: <AcademyPracticePage /> },
        { path: 'exams/:productSlug/mock/:paperId', element: <AcademyMockExamPage /> },
        { path: 'workspace', element: <WorkspacePage /> },
        { path: 'companion', element: <CompanionRoute /> },
        { path: 'companion/design', element: <CompanionDesignRoute /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },

    { path: '*', element: <NotFoundPage /> },
  ],
  {
    future: { v7_relativeSplatPath: true },
  },
);
